import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Icon } from '@iconify/react';

const SAMPLE_IMAGES = ['/sample-meme1.png', '/sample-meme2.png', '/sample-original.png'];
const LOADING_TEXTS = ['이미지를 생성하는 중', '잠시만 기다려 주세요', '나노바나나 껍질 벗기는중'];

export default function PhotoLoadingPopup({ show, zIndex = 2400, loadingImageIndex = 0, loadingTextIndex = 0 }) {
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="photo-loading-popup-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          style={{ zIndex }}
        >
          <motion.div
            className="photo-loading-popup"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
          >
            <div className="photo-loading-popup-content">
              <div className="photo-loading-notice">
                이미지 변환에는 30~40초가 소요됩니다.
              </div>
              <div className="photo-loading-image-container">
                <AnimatePresence mode="wait">
                  <motion.img
                    key={loadingImageIndex}
                    src={SAMPLE_IMAGES[loadingImageIndex] || SAMPLE_IMAGES[0]}
                    alt="로딩 샘플"
                    className="photo-loading-sample-image"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 2 }}
                  />
                </AnimatePresence>
                <div className="photo-loading-spinner">
                  <Icon icon="solar:refresh-bold" className="photo-loading-spinner-icon" width={48} height={48} style={{ animation: 'spin 1s linear infinite' }} />
                </div>
              </div>

              <div className="photo-loading-text-container">
                <AnimatePresence mode="wait">
                  <motion.p
                    key={loadingTextIndex}
                    className="photo-loading-text"
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -10 }}
                    transition={{ duration: 2 }}
                  >
                    {LOADING_TEXTS[loadingTextIndex] || LOADING_TEXTS[0]}
                  </motion.p>
                </AnimatePresence>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}


